<template>
  <div id="footer">
    Copyright 2019 &copy;
    <a href="https://incheon.devs.co.kr" target="_blank">Incheon Dev's</a>
    with <a href="https://labs.sbsoft.kr" target="_blank">SB-Labs</a>
    all rights reserved
  </div>
</template>

<script>
export default {
    name: "sb-footer"
}
</script>

<style>
#footer {
  position: fixed;
  /* position: absolute; */
  bottom: 0;
  left: 0;
  width: calc(100% - 300px);
  margin-left: 300px;
  background: #008080;
  text-align: center;
  padding: 8px;
  color: #eeeeee;
  font-size: 9pt;
  z-index: 99;
}
#footer.menu-hide {
  width: 100%;
  margin-left: 0;
}
#footer a {
  color: #ffffff;
}
</style>
